import React from 'react';
import { eFeePropertyNames } from 'types/order/fees/eFeePropertyNames';
import { NumberField } from 'ui-toolkit';
import { IFieldProps } from './IFieldProps';

export const NumberOfMonths: React.FC<IFieldProps> = ({ baseName, readOnly }) => (
  <NumberField
    name={`${baseName}.numericFeePropertyValues.${eFeePropertyNames.NumberOfMonths}`}
    label={'Number of Months'}
    placeholder={'0'}
    mode={'default'}
    data-test-id={'fee-detail-number-of-months'}
    readOnly={readOnly}
  />
);
